import { render } from "./ProcessDetailsView.vue?vue&type=template&id=0543bcee"
import script from "./ProcessDetailsView.vue?vue&type=script&lang=js"
export * from "./ProcessDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__